'use client'

import { cva } from 'class-variance-authority'
import Markdown from 'markdown-to-jsx'

import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/src/domains/design-system/components/Accordion'

enum StrapiFaqVariant {
  BUSINESS = 'business',
  PUBLIC = 'public',
}

export interface StrapiFaqItem {
  question?: string
  answer?: string
}

export interface StrapiFaqProps {
  items: StrapiFaqItem[]
  variant?: `${StrapiFaqVariant}`
}

interface AnsweredStrapiFaqItem extends StrapiFaqItem {
  question: string
  answer: string
}

const strapiFaqLinkVariants = cva('underline hover:no-underline', {
  variants: {
    variant: {
      [`${StrapiFaqVariant.BUSINESS}`]: 'text-pink-500 hover:text-pink-500',
      [`${StrapiFaqVariant.PUBLIC}`]: 'text-peach-500 hover:text-peach-500',
    },
  },
  defaultVariants: {
    variant: StrapiFaqVariant.PUBLIC,
  },
})

const isAnswered = (item: StrapiFaqItem): item is AnsweredStrapiFaqItem => Boolean(item.question && item.answer)

export const StrapiFaq = ({ items, variant }: StrapiFaqProps) => {
  const answeredItems = items.filter(isAnswered)

  if (answeredItems.length === 0) {
    return null
  }

  return (
    <Accordion type="multiple" className="flex flex-col gap-4">
      {answeredItems.map(({ question, answer }, index) => (
        <AccordionItem key={`faq-${index}`} value={`faq-${index}`}>
          <AccordionTrigger>{question}</AccordionTrigger>
          <AccordionContent>
            <div className="flex flex-col gap-4">
              <Markdown
                options={{
                  overrides: { a: { props: { className: strapiFaqLinkVariants({ variant }) } } },
                }}
              >
                {answer}
              </Markdown>
            </div>
          </AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  )
}
